interface Props {
  controls: string
  label: string
  onClick: VoidFunction
  isActive: boolean
  btnId?: string
  btnStyle?: string
  showSeperator?: boolean
  activeStyle?: string
  inActiveStyle?: string
  seperatorStyle?: string
}

const TabHeaderButton = ({
  controls,
  label,
  onClick,
  isActive,
  btnId,
  showSeperator = false,
  btnStyle = 'w-full h-full text-lg leading-[21px] transition-all duration-300',
  activeStyle = 'text-white bg-primary-100',
  inActiveStyle = '',
  seperatorStyle = 'absolute top-1/2 -translate-y-1/2 right-0 h-11 w-px bg-neutral-30',
  ...props
}: Props) => (
  <>
    <button
      type="button"
      className={`${btnStyle} ${isActive ? activeStyle : inActiveStyle}`}
      role="tab"
      aria-controls={controls}
      aria-selected={isActive}
      onClick={onClick}
      id={btnId}
    >
      {label}
    </button>
    {showSeperator ? <span className={seperatorStyle} /> : null}
  </>
)

export default TabHeaderButton
